// const API_BASE = (process.env.VUE_APP_API_BASE || '').replace(/\/$/, '')
const API_BASE  =  'https://admin.myshengtu.cn'
function encodeForm(data) {
  const body = new URLSearchParams()
  Object.keys(data || {}).forEach(key => {
    const value = data[key]
    if (value !== undefined && value !== null && value !== '') body.append(key, value)
  })
  return body
}

export async function request(path, options = {}) {
  const token = localStorage.getItem('ai_token')
  const headers = { ...(options.headers || {}) }
  if (token) headers.Authorization = `Bearer ${token}`

  let body = options.body
  if (body && !(body instanceof FormData)) {
    body = encodeForm(body)
    headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
  }

  const response = await fetch(`${API_BASE}${path}`, {
    method: options.method || 'GET',
    headers,
    body
  })
  const result = await response.json().catch(() => null)
  if (!result) throw new Error('服务响应异常，请稍后重试')
  if (result.code !== 1) {
    if (result.code === 401) window.dispatchEvent(new CustomEvent('auth-expired'))
    throw new Error(result.msg || '请求失败')
  }
  return result.data
}

export const api = {
  login: data => request('/api/user/login', { method: 'POST', body: data }),
  register: data => request('/api/user/register', { method: 'POST', body: data }),
  logout: () => request('/api/user/logout', { method: 'POST' }),
  profile: () => request('/api/user/index'),
  config: () => request('/api/ai/config'),
  generate: data => request('/api/ai/generate', { method: 'POST', body: data }),
  edit: (data, image) => {
    const body = new FormData()
    Object.keys(data || {}).forEach(key => {
      const value = data[key]
      if (value !== undefined && value !== null && value !== '') body.append(key, value)
    })
    body.append('image', image)
    return request('/api/ai/edit', { method: 'POST', body })
  },
  gallery: params => request(`/api/ai/history?${new URLSearchParams(params).toString()}`),
  downloadWork: async id => {
    const token = localStorage.getItem('ai_token')
    const response = await fetch(`${API_BASE}/api/ai/download?id=${encodeURIComponent(id)}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    })
    if (!response.ok) {
      const result = await response.json().catch(() => null)
      throw new Error((result && result.msg) || '下载失败')
    }
    return response.blob()
  },
  removeWork: id => request('/api/ai/delete', { method: 'POST', body: { id } }),
  plans: () => request('/api/recharge/plans'),
  createRecharge: data => request('/api/recharge/create', { method: 'POST', body: data }),
  rechargeStatus: orderNo => request(`/api/recharge/status?order_no=${encodeURIComponent(orderNo)}`)
}

export function assetUrl(url) {
  if (!url || /^(https?:|data:|blob:)/i.test(url)) return url || ''
  return `${API_BASE}${url.startsWith('/') ? '' : '/'}${url}`
}
